import { ReactElement } from 'react'
import { Box, Typography } from '@mui/material'
import { ChangeSummaryEntry } from '../changeSummary'
import ElementLink from './ElementLink'

interface Props {
  entry: ChangeSummaryEntry
}

/**
 * One affected element of the change summary: its name -- an element link
 * (hover outlines it, click marks it) when the agent linked it -- and what
 * changed on it.
 */
const ChangeSummaryItem = ({ entry }: Props): ReactElement => (
  <Box data-cy="ai-chat-change-summary-item">
    {entry.subject !== null && (
      <Typography variant="body2" fontWeight="bold">
        {entry.guid ? <ElementLink guid={entry.guid}>{entry.subject}</ElementLink> : entry.subject}
      </Typography>
    )}
    <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
      {entry.changes.map((change, index) => (
        <Typography key={index} component="li" variant="body2">
          {change}
        </Typography>
      ))}
    </Box>
  </Box>
)

export default ChangeSummaryItem
